<template>
  <v-card
    class="mt-2"
    rounded="xl"
    :ripple="false"
  >
    <v-card-text>
      <v-row
        no-gutters
        align="center"
      >
        <v-col cols="2">
          <div>TÌM KIẾM LỊCH TÀU</div>
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="typedSearch"
            label="Nhập mã chuyến tàu"
            prepend-inner-icon="mdi-magnify"
            type="text"
            dense
            solo
            flat
            outlined
            hide-details
            class="pr-2"
          />
        </v-col>
        <v-col cols="3">
          <v-dialog
            ref="dialog"
            v-model="modal"
            persistent
            max-width="670px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                class="pr-2"
                :value="dateRangeText"
                label="Ngày đi - Ngày đến"
                hide-details
                append-icon="mdi-calendar-month"
                readonly
                dense
                outlined
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dates"
              @change="onChangeDates"
              range
              landscape
              full-width
              :allowedDates="allowedDates"
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="modal = false"
              >
                Hủy
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="onSelectEtdEta"
              >
                Chọn
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="3">
          <v-badge
            :value="advancedFilterCount > 0"
            color="error"
            :content="`${advancedFilterCount}`"
            overlap
            style="width: 100%"
          >
            <v-btn
              style="height: 40px"
              width="100%"
              color="primary"
              :outlined="!isExpandFilter"
              :ripple="false"
              @click="isExpandFilter = !isExpandFilter"
            >
              <v-icon
                left
                v-text="
                  isExpandFilter
                    ? 'mdi-chevron-double-up'
                    : 'mdi-chevron-double-down'
                "
              >
              </v-icon>
              Tìm kiếm nâng cao
            </v-btn>
          </v-badge>
        </v-col>
      </v-row>

      <v-expand-transition>
        <div v-show="isExpandFilter">
          <v-row no-gutters>
            <div
              style="font-size: 12px"
              class="mt-6 pb-2"
            >
              <v-icon> mdi-filter-variant </v-icon>
              BỘ LỌC NÂNG CAO
            </div>
          </v-row>
          <v-row
            no-gutters
            align="center"
            class="mb-4"
          >
            <v-col cols="4">
              <VesselPicker
                :value="selectedVesselCode"
                @change="onSelectVessel"
                class="pr-2"
                label="Chọn tàu"
                clearable
              />
            </v-col>
            <v-col cols="4">
              <PortPicker
                :value="selectedPolCode"
                @change="onSelectPOL"
                class="pr-2"
                label="Chọn POL"
                clearable
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="4">
              <PortPicker
                :value="selectedPodCode"
                @change="onSelectPOD"
                class="pr-2"
                label="Chọn POD"
                clearable
                dense
                outlined
                hide-details
              />
            </v-col>
          </v-row>
        </div>
      </v-expand-transition>
    </v-card-text>
  </v-card>
</template>

<script>
import dayjs from 'dayjs';
import PortPicker from '@/components/shared/local/vsl/PortPicker.vue';
import { mapActions, mapMutations, mapState } from 'vuex';
import VesselPicker from '@/components/shared/local/vsl/VesselPicker.vue';
import { debounce, pluck } from 'rxjs/operators';
import { timer } from 'rxjs';

export default {
  components: { PortPicker, VesselPicker },
  data: () => ({
    dates: [dayjs().format('YYYY-MM-DD')],
    modal: false,
    isExpandFilter: false,
    typedSearch: '',
    selectedVesselCode: null,
    selectedEtdEta: [],
    selectedPolCode: null,
    selectedPodCode: null,
  }),
  computed: {
    ...mapState('vsl/vesselSchedule', {
      queryParams: 'vesselScheduleListQueryParams',
      vesselScheduleListLoading: 'vesselScheduleListLoading',
    }),
    isLoading: {
      get() {
        return this.vesselScheduleListLoading;
      },
      set(value) {
        this.SET_VESSEL_SCHEDULE_LIST_LOADING(value);
      },
    },
    dateRangeText() {
      const formated = this.selectedEtdEta.map((date) => {
        return dayjs(date).format('DD.MM.YYYY');
      });
      return formated.join(' - ');
    },
    advancedFilterCount() {
      const filters = {
        selectedVesselCode: this.selectedVesselCode,
        selectedPolCode: this.selectedPolCode,
        selectedPodCode: this.selectedPodCode,
      };
      console.log('[LOG] : filters', filters);
      const count = Object.keys(filters).filter(
        (x) => filters[x] != undefined
      ).length;
      console.log('[LOG] : count', count);
      return count;
    },
  },
  created() {
    let { search, vessel_code, pol_code, pod_code, from_etd, to_eta } =
      this.$route.query;
    if (to_eta) {
      this.selectedEtdEta = [from_etd, to_eta];
    } else {
      this.selectedEtdEta = [from_etd];
    }
    this.typedSearch = search;
    this.selectedVesselCode = vessel_code;
    this.selectedPolCode = pol_code;
    this.selectedPodCode = pod_code;

    this.$watchAsObservable('typedSearch')
      .pipe(
        pluck('newValue'),
        debounce(() => {
          this.isLoading = true;
          return timer(500);
        })
      )
      .subscribe(async (value) => {
        console.log('[LOG] : value', value);
        try {
          await this.$router
            .push({
              path: 'request-a-quote',
              query: {
                ...this.$route.query,
                search: value,
              },
            })
            .catch(() => {});

          this.SET_VESSEL_SCHEDULE_LIST_QUERY_PARAMS({ search: value });
          await this.fetchVesselScheduleList();
        } finally {
          this.isLoading = false;
        }
      });
  },
  // watch: {
  //   advancedFilter: {
  //     handler(value) {
  //       console.log('[LOG] : value', value);
  //     },
  //     deep: true,
  //     immediate: true,
  //   },
  // },
  methods: {
    ...mapMutations('vsl/vesselSchedule', [
      'SET_VESSEL_SCHEDULE_LIST_QUERY_PARAMS',
      'SET_VESSEL_SCHEDULE_LIST_LOADING',
    ]),
    ...mapActions('vsl/vesselSchedule', ['fetchVesselScheduleList']),
    allowedDates(value) {
      return dayjs(value) > dayjs().subtract(1, 'day');
    },
    async onSelectVessel(item) {
      try {
        this.isLoading = true;
        await this.$router
          .push({
            path: 'request-a-quote',
            query: {
              ...this.$route.query,
              vessel_code: item?.code,
            },
          })
          .catch(() => {});
        this.selectedVesselCode = item?.code;
        this.SET_VESSEL_SCHEDULE_LIST_QUERY_PARAMS({ vesselCode: item?.code });
        await this.fetchVesselScheduleList();
      } finally {
        this.isLoading = false;
      }
    },
    async onSelectPOL(item) {
      try {
        this.isLoading = true;
        await this.$router
          .push({
            path: 'request-a-quote',
            query: {
              ...this.$route.query,
              pol_code: item?.code,
            },
          })
          .catch(() => {});
        this.selectedPolCode = item?.code;
        this.SET_VESSEL_SCHEDULE_LIST_QUERY_PARAMS({ polCode: item?.code });
        await this.fetchVesselScheduleList();
      } finally {
        this.isLoading = false;
      }
    },
    async onSelectPOD(item) {
      try {
        this.isLoading = true;
        await this.$router
          .push({
            path: 'request-a-quote',
            query: {
              ...this.$route.query,
              pod_code: item?.code,
            },
          })
          .catch(() => {});
        this.selectedPodCode = item?.code;
        this.SET_VESSEL_SCHEDULE_LIST_QUERY_PARAMS({ podCode: item?.code });
        await this.fetchVesselScheduleList();
      } finally {
        this.isLoading = false;
      }
    },
    onChangeDates(value) {
      this.dates = value;
    },
    async onSelectEtdEta() {
      try {
        this.isLoading = true;
        this.modal = false;
        if (this.dates.length > 1) {
          if (dayjs(this.dates[0]).isAfter(dayjs(this.dates[1]))) {
            this.dates = [this.dates[1], this.dates[0]];
          }
        }
        this.selectedEtdEta = this.dates;
        await this.$router
          .push({
            path: 'request-a-quote',
            query: {
              ...this.$route.query,
              from_etd: this.selectedEtdEta[0]
                ? this.selectedEtdEta[0]
                : undefined,
              to_etd: this.selectedEtdEta[1]
                ? this.selectedEtdEta[1]
                : undefined,
            },
          })
          .catch(() => {});
        this.SET_VESSEL_SCHEDULE_LIST_QUERY_PARAMS({
          etdEta: this.selectedEtdEta,
        });
        await this.fetchVesselScheduleList();
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style></style>
